/**
 * AI tool options for the PSCX Get Started intake. Kept free of server-only
 * dependencies so client components can import it without pulling in nodemailer.
 */
/** AI assistants a prospect may already run. Values are stable ids; labels are the display names. */
export const AI_TOOL_OPTIONS = [
  { value: "chatgpt", label: "ChatGPT" },
  { value: "claude", label: "Claude" },
  { value: "gemini", label: "Gemini" },
  { value: "copilot", label: "Microsoft Copilot" },
  { value: "grok", label: "Grok" },
  { value: "other", label: "Other or in-house" },
] as const;
export type AiToolId = (typeof AI_TOOL_OPTIONS)[number]["value"];
export const AI_TOOL_IDS = AI_TOOL_OPTIONS.map((option) => option.value) as [AiToolId, ...AiToolId[]];
export const aiToolLabel = (id: AiToolId): string => AI_TOOL_OPTIONS.find((option) => option.value === id)?.label ?? id;
